import React from "react";
import CelebrantsGrid from "../../components/celebrant/celebrantgrid";
import celebrant from "../../assets/celebrant.png";

// const celebrants = [
//   {
//     name: "Adebimpe Peters",
//     role: "HR Personnel",
//     date: "31st March",
//     imageUrl: celebrant,
//   },
//   {
//     name: "Adebimpe Peters",
//     role: "HR Personnel",
//     date: "31st March",
//     imageUrl: celebrant,
//   },
//   {
//     name: "Adebimpe Peters",
//     role: "HR Personnel",
//     date: "31st March",
//     imageUrl: celebrant,
//   },
//   {
//     name: "Adebimpe Peters",
//     role: "HR Personnel",
//     date: "31st March",
//     imageUrl: celebrant,
//   },
//   {
//     name: "Adebimpe Peters",
//     role: "HR Personnel",
//     date: "31st March",
//     imageUrl: celebrant,
//   },
//   {
//     name: "Adebimpe Peters",
//     role: "HR Personnel",
//     date: "31st March",
//     imageUrl: celebrant,
//   },
//   {
//     name: "Adebimpe Peters",
//     role: "HR Personnel",
//     date: "31st March",
//     imageUrl: celebrant,
//   },
//   // ...repeat or map dynamically from data source
// ];

console.log("EEEERRRRRIIIU");

console.log("celebrant import ->", celebrant);

const BirthdayCelebrants = () => {
  const celebrants = [
    {
      id: 1,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      imageUrl: celebrant, // replace with actual imageUrl
      isToday: false,
    },
    {
      id: 2,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      imageUrl: celebrant,
      isToday: false,
    },
    {
      id: 3,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "Today's Celebrant",
      imageUrl: celebrant,
      isToday: true, // highlight today's celebrant
    },
    {
      id: 4,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      imageUrl: celebrant,
      isToday: false,
    },
    {
      id: 5,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      imageUrl: celebrant,
      isToday: false,
    },
    {
      id: 6,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      imageUrl: celebrant,
      isToday: false,
    },
  ];
  return (
    <div>
      <div>
        <CelebrantsGrid
          title="Birthday Celebrants - September"
          celebrants={celebrants}
        />
        {/* <CelebrantsGrid
          title="Work Anniversaries - March"
          celebrants={celebrants}
        /> */}
      </div>
    </div>
  );
};

export default BirthdayCelebrants;
